"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMPAIGN_GROUP_SETTLEMENT_SUBJECT = exports.CAMPAIGN_GROUP_SETTLEMENT_EVENT_VERSION = void 0;
exports.CAMPAIGN_GROUP_SETTLEMENT_EVENT_VERSION = 1;
exports.CAMPAIGN_GROUP_SETTLEMENT_SUBJECT = "wallet.campaign-group-settlement.completed.v1";
